import { cx } from "../../../utils/classNames";
import ui from "../../../components/ui/ui.module.css";
import styles from "../Performance.module.css";

// Numbered entries (e.g. Major Accomplishments 1..3). `onChange` absent = read-only.
const TextListSection = ({ section, answer = {}, onChange }) => {
  const max = section.maxEntries ?? 10;
  const entries = answer.entries ?? [];

  if (!onChange) {
    const filled = entries.filter((e) => e?.trim());
    return filled.length ? (
      <ol className={styles.entryList}>
        {filled.map((entry, i) => (
          <li key={i}>{entry}</li>
        ))}
      </ol>
    ) : (
      <p className={cx(ui.muted, "mb-0")}>Nothing entered.</p>
    );
  }

  // Always show at least the minimum (or one) input.
  const shownCount = Math.min(
    max,
    Math.max(entries.length, section.minEntries ?? 1, 1),
  );
  const shown = Array.from({ length: shownCount }, (_, i) => entries[i] ?? "");

  const update = (next) => onChange({ ...answer, entries: next });

  return (
    <>
      {shown.map((entry, i) => (
        <div key={i} className={styles.entryRow}>
          <span className={styles.entryIndex}>{i + 1}.</span>
          <input
            className={ui.input}
            maxLength={2000}
            value={entry}
            onChange={(e) =>
              update(shown.map((v, j) => (j === i ? e.target.value : v)))
            }
          />
          {shownCount > 1 && (
            <button
              type="button"
              className={ui.iconButton}
              onClick={() => update(shown.filter((_, j) => j !== i))}
              aria-label={`Remove entry ${i + 1}`}
            >
              <i className="bi bi-x-lg"></i>
            </button>
          )}
        </div>
      ))}
      {shownCount < max && (
        <button
          type="button"
          className={ui.linkButton}
          onClick={() => update([...shown, ""])}
        >
          <i className="bi bi-plus"></i> Add entry
        </button>
      )}
    </>
  );
};

export default TextListSection;
